/* styles.ts generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["as", "style"],
  _excluded6 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _25 = "._1i4qfg65{overflow-wrap:anywhere}";
const _24 = "._vwz41j6v{line-height:1rem}";
const _23 = "._k48p1nn1{font-weight:400}";
const _22 = "._1yt41bpf{padding:var(--ds-space-100,8px) 0}";
const _21 = "._4t3i1k8s{height:1.5rem}";
const _20 = "@media (min-width:64rem){._isu4u2gc{margin-bottom:var(--ds-space-100,8px)}}";
const _19 = "._1gz3idpf dd{margin-left:0}";
const _18 = "._zf26idpf dd{margin-bottom:0}";
const _17 = "._1coridpf dd{margin-right:0}";
const _16 = "._16a7idpf dd{margin-top:0}";
const _15 = "._otyrpxbi{margin-bottom:var(--ds-space-200,1pc)}";
const _14 = "._1e0c1txw{display:flex}";
const _13 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const _12 = "._18u0idpf{margin-left:0}";
const _11 = "._otyridpf{margin-bottom:0}";
const _10 = "._2hwxidpf{margin-right:0}";
const _9 = "._19pkidpf{margin-top:0}";
const _8 = "._19bvidpf{padding-left:0}";
const _7 = "._n3tdidpf{padding-bottom:0}";
const _6 = "._u5f3idpf{padding-right:0}";
const _5 = "._ca0qidpf{padding-top:0}";
const _4 = "._qtt8glyw{list-style:none}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives';
import { BodyNormal, SubtleLink } from '@atlassian/mpac-primitives';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _3 = "._1yt44ar7{padding:var(--ds-space-200,1pc) var(--ds-space-300,24px)}";
const _2 = "._2rko1crf{border-radius:9pt}";
const _ = "._19itzgxb{border:1px solid var(--ds-border,#091e4224)}";
export const ContactCard = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "section",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19itzgxb _2rko1crf _1yt44ar7", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ContactCard.displayName = 'ContactCard';
}
export const ContactList = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "dl",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_4, _5, _6, _7, _8, _9, _10, _11, _12]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ContactList.displayName = 'ContactList';
}
export const ContactItem = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_13, _14, _15, _16, _17, _18, _19, _20]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulpu2gc _1e0c1txw _otyrpxbi _16a7idpf _1coridpf _zf26idpf _1gz3idpf _isu4u2gc", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ContactItem.displayName = 'ContactItem';
}
export const IconContainer = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = "dt",
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_21]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_4t3i1k8s", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  IconContainer.displayName = 'IconContainer';
}
export const ContactDetail = forwardRef((_ref5, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref5,
    __cmplp = _objectWithoutProperties(_ref5, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_9, _10, _11, _12]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _2hwxidpf _otyridpf _18u0idpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ContactDetail.displayName = 'ContactDetail';
}
export const ContactLink = forwardRef((_ref6, __cmplr) => {
  let {
      as: C = SubtleLink,
      style: __cmpls
    } = _ref6,
    __cmplp = _objectWithoutProperties(_ref6, _excluded6);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_22, _23, _24, _25]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt41bpf _k48p1nn1 _vwz41j6v _1i4qfg65", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ContactLink.displayName = 'ContactLink';
}